import React from "react";
import "../styles/style__estudios.css";
import PixelArt from "./pixelArt";

// Sprites de 16x16 basados en los lingotes y el diamante de Minecraft
const sprites = {
  bronce: {
    palette: {
      a: "#4d2b0f",
      b: "#a26023",
      c: "#673a11",
      d: "#cc7e33",
      e: "#ec9138",
      f: "#351c06",
      g: "#834c16",
      w: "#ffffff",
    },
    sprite: [
      "................",
      "................",
      "..........aa....",
      ".......aaabbc...",
      "....aaabddddbc..",
      ".aaabddddddddbc.",
      "awddddddddddwwec",
      "abwddddddwwwecbf",
      "abbwddwwwegccgbf",
      "abbbwwegccccbbbf",
      "agbbegccccbbgff.",
      ".agbegccggfff...",
      "..agbgafff......",
      "...aaff.........",
      "................",
      "................",
    ],
  },
  hierro: {
    palette: {
      a: "#424242",
      b: "#686868",
      c: "#818181",
      d: "#cacaca",
      e: "#f7f7f7",
      f: "#9a9a9a",
      g: "#5a5a5a",
      h: "#757575",
      i: "#dfdfdf",
      j: "#bdbdbd",
    },
    sprite: [
      "................",
      "................",
      "..........ab....",
      ".......aaaccb...",
      "....aaacddddcb..",
      ".aaacddddddddcb.",
      "aeddddddddddeedb",
      "afeddddddeeedgfa",
      "affeddeeedhgghfa",
      "afffeedhggggfffa",
      "acffihggggffhaa.",
      ".acfihggccaaa...",
      "..acjhbaaa......",
      "...aaaa.........",
      "................",
      "................",
    ],
  },
  diamante: {
    palette: {
      a: "#0c3730",
      b: "#ffffff",
      c: "#a2f6e7",
      d: "#d1faf3",
      e: "#30dbbd",
      f: "#4aedd1",
      g: "#8cf4e2",
      h: "#209581",
      i: "#2ccdb1",
      j: "#1b7b6b",
    },
    sprite: [
      "................",
      "......aaaa......",
      ".....abbbba.....",
      "....abcccdea....",
      "...abdccbffa....",
      "...abcbdddfea...",
      "..abcbgggghfa...",
      "..abcdgggghfea..",
      "..abdigggghjja..",
      "..abffhhhhiiha..",
      "...afjiiiijia...",
      "...aejiiiijha...",
      "....ahiiiiha....",
      ".....aaaaaa.....",
      "................",
      "................",
    ],
  },
};

const estudios = [
  {
    material: "bronce",
    nivel: "Bronce",
    titulo: "Bachillerato",
    centro: "Colegio de La Salle",
  },
  {
    material: "hierro",
    nivel: "Hierro",
    titulo: "Ingeniería Informática",
    centro: "Universidad Europea",
  },
  {
    material: "diamante",
    nivel: "Diamante",
    titulo: "Máster en Inteligencia Artificial",
    centro: "Universidad Europea",
  },
];

function Estudios() {
  return (
    <div className="EstudiosPixel flex__column align__center">
      <h1 className="first__font color__white size__24px">Estudios</h1>
      <p className="estudios__subtitulo first__font">Árbol de crafteo</p>
      <div className="estudios__progreso">
        {estudios.map((estudio, index) => (
          <React.Fragment key={estudio.material}>
            {index > 0 && (
              <span className="estudios__flecha first__font" aria-hidden="true">
                ▶
              </span>
            )}
            <div className={`estudio__card estudio__card--${estudio.material}`}>
              <div className="estudio__slot">
                <PixelArt
                  sprite={sprites[estudio.material].sprite}
                  palette={sprites[estudio.material].palette}
                  size={72}
                  title={estudio.nivel}
                />
              </div>
              <span className="estudio__nivel first__font">
                Nv.{index + 1} {estudio.nivel}
              </span>
              <h2 className="estudio__titulo first__font">{estudio.titulo}</h2>
              <p className="estudio__centro third__font">{estudio.centro}</p>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default Estudios;
